import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { compose } from 'redux'
import styles from './headerBottom.module.scss'
import books from '../../../assets/books.png'
import MyPreloader from '../../commons/preloader/preloader'
import { keyGenerator } from '../../../helpers/helpers'
import BasketElementText from '../../basket/basketElement/basketElement'
import withRouter from '../../../hooks/withRouter'
import { setFilters } from '../../../redux/book.slice'
import { RootState } from '../../../redux/store'
import { Words } from '../../../types/lang'
import { Book, BookFilters } from '../../../types/book'
import { SearchItem as SearchItemType } from '../../../types/search'
import {
  resetFoundResults,
  searchByName,
  setSearchPageFoundResults,
} from '../../../redux/search.slice'
import SearchItem from '../../searchItem/searchItem'

interface HeaderBottomProps {
  words: Words
  count: number
  price: number
  loading: boolean
  language: string
  foundBooks: SearchItemType[]
  foundAuthors: SearchItemType[]
  foundPublishers: SearchItemType[]
  setFilters: (filters: BookFilters) => void
  searchByName: ({ name, language }: { name: string; language: string }) => void
  resetFoundResults: () => void
  setSearchPageFoundResults: () => void
}

const HeaderBottom = (props: HeaderBottomProps) => {
  const {
    words,
    count,
    loading,
    language,
    price,
    foundBooks,
    foundAuthors,
    foundPublishers,
    setFilters,
    searchByName,
    resetFoundResults,
    setSearchPageFoundResults,
  } = props
  const [search, setSearch] = useState<string>('')
  const [timer, setTimer] = useState<any>(null)
  const [isSearch, setIsSearch] = useState<boolean>(false)

  const onWindowClick = () => {
    setSearch('')
  }

  useEffect(() => {
    window.addEventListener('click', onWindowClick)
    window.addEventListener('blur', onWindowClick)

    return () => {
      window.removeEventListener('click', onWindowClick)
      window.removeEventListener('blur', onWindowClick)
    }
  }, [])

  useEffect(() => {
    // if (search) {
    //   setIsSearch(true)
    // }

    if (timer) {
      clearTimeout(timer)
    }

    if (search) {
      setTimer(
        setTimeout(() => {
          searchByName({ name: search, language: language })
        }, 1500),
      )
    } else {
      setIsSearch(false)
    }

    return () => {
      clearInterval(timer)
    }
  }, [search])

  const onClickSearch = () => {
    setSearchPageFoundResults()
  }

  return (
    <div className={styles.container}>
      <div className={styles.leftPart}>
        <NavLink to="/" className={styles.title}>
          <img src={books} alt="" />
          <div>
            <span className={styles.titleFirstLetter}>B</span>ookly
          </div>
        </NavLink>
      </div>
      <div className={styles.rightPart}>
        <div className={styles.rightContainer}>
          <div className={styles.searchContainer}>
            <NavLink
              className={styles.btnSearch}
              to={search ? `/search/${search}` : '#'}
              onClick={onClickSearch}
            >
              <i className="fas fa-search"></i>
            </NavLink>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className={styles.inputSearch}
              placeholder={words.search}
            />
            {search && (
              <div
                onClick={(e) => e.stopPropagation()}
                className={styles.resultPanel}
              >
                {loading ? (
                  <>
                    {foundBooks?.length > 0 ||
                    foundAuthors?.length > 0 ||
                    foundPublishers?.length > 0 ? (
                      <>
                        {foundBooks?.length > 0 && <div>{words.books}</div>}
                        <div>
                          {foundBooks?.length > 0 &&
                            foundBooks?.map((searchItem: SearchItemType) => {
                              return (
                                <div
                                  onClick={() => setSearch('')}
                                  className={styles.item}
                                  key={searchItem.id}
                                >
                                  <img src={searchItem.image} alt="" />
                                  <div className={styles.titleContainer}>
                                    {/* @ts-ignore */}
                                    <SearchItem
                                      nameObj={searchItem.name}
                                      id={searchItem.id}
                                      type="books"
                                    />
                                  </div>
                                </div>
                              )
                            })}
                        </div>
                        {foundAuthors?.length > 0 && <div>{words.authors}</div>}
                        <div>
                          {foundAuthors?.length > 0 &&
                            foundAuthors?.map((searchItem: SearchItemType) => {
                              return (
                                <div
                                  onClick={() => setSearch('')}
                                  className={styles.item}
                                  key={searchItem.id}
                                >
                                  <img src={searchItem.image} alt="" />
                                  <div className={styles.titleContainer}>
                                    {/* @ts-ignore */}
                                    <SearchItem
                                      nameObj={searchItem.name}
                                      id={searchItem.id}
                                      type="authors"
                                    />
                                  </div>
                                </div>
                              )
                            })}
                        </div>
                        {foundPublishers?.length > 0 && (
                          <div>{words.publishers}</div>
                        )}
                        <div>
                          {foundPublishers?.length > 0 &&
                            foundPublishers?.map(
                              (searchItem: SearchItemType) => {
                                return (
                                  <div
                                    onClick={() => setSearch('')}
                                    className={styles.item}
                                    key={searchItem.id}
                                  >
                                    <img src={searchItem.image} alt="" />
                                    <div className={styles.titleContainer}>
                                      {/* @ts-ignore */}
                                      <SearchItem
                                        nameObj={searchItem.name}
                                        id={searchItem.id}
                                        type="publishers"
                                      />
                                    </div>
                                  </div>
                                )
                              },
                            )}
                        </div>
                      </>
                    ) : (
                      <div className={styles.noResultsFound}>
                        {words.noResultsFound}
                      </div>
                    )}
                  </>
                ) : (
                  <MyPreloader size="extra_small" />
                )}
              </div>
            )}
          </div>
          <div className={styles.infoContainer}>
            <NavLink to="/contacts" className={styles.infoItem}>
              {words.contacts}
            </NavLink>
            <div className={styles.separator}></div>
            <NavLink to="/about_us" className={styles.infoItem}>
              {words.aboutUs}
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  )
}

let mapStateToProps = (state: RootState) => {
  return {
    words: state.main.words,
    foundBooks: state.search.foundBooks,
    foundAuthors: state.search.foundAuthors,
    foundPublishers: state.search.foundPublishers,
    loading: state.search.loading,
    language: state.main.language,
  }
}

export default connect(mapStateToProps, {
  setFilters,
  searchByName,
  resetFoundResults,
  setSearchPageFoundResults,
})(
  //@ts-ignore
  HeaderBottom,
)
